var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "section-title",
        { attrs: { icon: "mdi-alert-outline" } },
        [
          _c(
            "v-row",
            { attrs: { "no-gutters": "", align: "center" } },
            [
              _c("div", [_vm._v("Interrupciones")]),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "hidden-sm-and-down ma-2",
                  attrs: { color: "green", dark: "" },
                  on: {
                    click: function($event) {
                      return _vm.$refs.modal.open()
                    }
                  }
                },
                [_vm._v("DESCARGAR INTERRUPCIONES")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("download-incident", { ref: "modal" }),
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            [
              _c("v-text-field", {
                attrs: {
                  "append-icon": "mdi-magnify",
                  label: "Buscar",
                  "single-line": "",
                  "hide-details": ""
                },
                model: {
                  value: _vm.searchIncidents,
                  callback: function($$v) {
                    _vm.searchIncidents = $$v
                  },
                  expression: "searchIncidents"
                }
              })
            ],
            1
          ),
          _c("v-data-table", {
            staticClass: "elevation-1",
            attrs: {
              headers: _vm.headersIncidents,
              search: _vm.searchIncidents,
              items: _vm.incidents,
              options: _vm.incidentsOptions,
              "items-per-page": _vm.itemsPerPageIncidents[3],
              "items-per-page-options": _vm.itemsPerPageIncidents,
              "footer-props": {
                itemsPerPageOptions: _vm.itemsPerPageIncidents,
                itemsPerPageText: "Cantidad de interrupciones por página",
                prevIcon: "",
                nextIcon: "",
                pageText: ""
              },
              loading: _vm.isFetchingIncidents,
              "loading-text":
                "Obteniendo las interrupciones, espere un momento por favor"
            },
            on: {
              "update:options": function($event) {
                _vm.incidentsOptions = $event
              }
            },
            scopedSlots: _vm._u([
              {
                key: "no-data",
                fn: function() {
                  return [_vm._v(" No hay incidentes registrados ")]
                },
                proxy: true
              }
            ])
          }),
          _c(
            "div",
            { staticClass: "grey lighten-4 ma-0 py-2" },
            [
              _c("v-pagination", {
                attrs: {
                  length: _vm.historyOptions.incidents.pages,
                  "total-visible": 7
                },
                on: {
                  input: function($event) {
                    return _vm.changeIncidentsDayco()
                  }
                },
                model: {
                  value: _vm.pageIncidents,
                  callback: function($$v) {
                    _vm.pageIncidents = $$v
                  },
                  expression: "pageIncidents"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }